import { Injector, runInInjectionContext, signal } from '@angular/core';
import { AudTypes } from '@core/models/ApiFields/ig-field-values.types';
import { ResDataItem } from '@core/models/IApi';
import {
    AUD_ENTITIES,
    AudTimef,
    GenderAgeStore,
} from '@features/social-analysis/social-users/config/audience.config';
import { AudienceHttpBuilder } from '@features/social-analysis/social-users/services/audience.http';

export class AudienceState {
    audData = {
        [AUD_ENTITIES.GENDER]: signal<ResDataItem[] | null>(null),
        [AUD_ENTITIES.AGE]: signal<ResDataItem[] | null>(null),
        [AUD_ENTITIES.GENDER_AGE]: signal<GenderAgeStore>(null),
        [AUD_ENTITIES.COUNTRY]: signal<ResDataItem[] | null>(null),
        [AUD_ENTITIES.CITY]: signal<ResDataItem[] | null>(null),
    };
    isLoading = {
        [AUD_ENTITIES.GENDER]: signal(false),
        [AUD_ENTITIES.AGE]: signal(false),
        [AUD_ENTITIES.GENDER_AGE]: signal(false),
        [AUD_ENTITIES.COUNTRY]: signal(false),
        [AUD_ENTITIES.CITY]: signal(false),
    };
    isCity = signal(false);
    type!: AudTypes;

    #genderHttp!: AudienceHttpBuilder;
    #ageHttp!: AudienceHttpBuilder;
    #genderAgeHttp!: AudienceHttpBuilder;
    #countryHttp!: AudienceHttpBuilder;
    #cityHttp!: AudienceHttpBuilder;

    constructor(type: AudTypes, injector: Injector) {
        this.type = type;
        runInInjectionContext(injector, () => {
            this.#genderHttp = new AudienceHttpBuilder(type, AUD_ENTITIES.GENDER);
            this.#ageHttp = new AudienceHttpBuilder(type, AUD_ENTITIES.AGE);
            this.#genderAgeHttp = new AudienceHttpBuilder(type, AUD_ENTITIES.GENDER_AGE);
            this.#countryHttp = new AudienceHttpBuilder(type, AUD_ENTITIES.COUNTRY);
            this.#cityHttp = new AudienceHttpBuilder(type, AUD_ENTITIES.CITY);
        });
    }

    reqAllData(timeframe?: AudTimef) {
        this.#genderHttp.reqData(this, timeframe);
        this.#ageHttp.reqData(this, timeframe);
        this.#genderAgeHttp.reqData(this, timeframe);
        this.#cityHttp.reqData(this, timeframe);
        this.#countryHttp.reqData(this, timeframe);
    }

    reqCountryOrCity() {}
}
